import footer from './footer/index.js'
import header from './header/index.js'


const reportViewPort = function(){
    var vw = document.documentElement.clientWidth;
    var vh = document.documentElement.clientHeight;
    var sw = window.screen.width;
    var sh = window.screen.height;
    if ("//www.yunshuren.com/" != window.location.href) {

        var url = "/view_port_log.php";
        if (global_info && global_info.product_host) {
            url = "//" + global_info.product_host + url
        }
        $.post(url, { vw: vw, vh: vh, sw: sw, sh: sh }, function () { });
    }
}

function getUserHead() {
    var ajax_check_login_url = '/ajax_check_login.php';
    if (global_info && global_info.product_host) {
        ajax_check_login_url = "//" + global_info.product_host + ajax_check_login_url
    }
    $.ajaxSetup({
        crossDomain: true,
        xhrFields: {
            withCredentials: true
        }
    });

    $.post(ajax_check_login_url, function (data) {

        var div = $('<div></div>')
        $(div).html(data);

        var loginFlag = div.find('#foot_login_flag').val();
        if (loginFlag == 1) {
            var useImg = div.find('#header_user_img')
            var useName = div.find('.sign_in_bg span').text();
            if (device == 'mobile') {
                $('.mobile_header_menu a').attr('href', '/myself.html')
                $('.mobile_header_menu a svg').remove()
                $('.mobile_header_menu a ').append(useImg)
            } else {
                $('#login .user-login-item').attr('href', 'javascript:;')
                $('#login span').html(useName)
                $('#login .default-icon').html(useImg)

                var menus = div.find('.sign_in_contentbox');
                $('#login').append(menus)
            }
        }
    })
}
export {
    footer,
    header,
    reportViewPort,
    getUserHead
}